import React, { Component, Fragment } from 'react';
import InputPhoneNr from 'components/components/common/forms/InputPhoneNr';
import axios from 'components/AppRequest';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import { Link } from 'react-router-dom';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

class PhoneForm extends Component {
  constructor(props) {
    super(props);
    this.inputPhoneRef = React.createRef();
  }

  state = {
    errors: {},
    isLoading: false,
  }

  trans = (key,prefix = 'content.auth.phoneForm') => {
    return TransHelper.translate( this.props.locale, prefix + "." + key);
  }

  submitForm = (e) => {
    e.preventDefault();
    //reset errors
    this.props.changeShowCommunicate(false);
    var phoneError = this.inputPhoneRef.current.validateForm();
    if (phoneError === null) {
      this.setState({
        errors: {},
        isLoading: true,
      });
      this.sendRequest();
    } else {
      this.setState({ errors: { phone: phoneError } });
    }
  }

  sendRequest = () => {
    const { phoneCountry, phone } = this.props;
    var wholePhone = phoneCountry.label + phone;
    axios.post('/pwa/registration/request-change-phone', { phone: wholePhone })
      .then(response => {
        this.setState({ isLoading: false });
        this.props.toggleView();
      })
      .catch(err => {
        console.log("err", err.response)
        this.setState({
          errors: err.response.data.errors,
          isLoading: false
        });
      });
  }

  render() {
    const { errors, isLoading } = this.state;
    const { phoneCountry, phone } = this.props;
    return (
      <Fragment>
        <header className="head mb-30">
          <h3>{this.trans('title')}</h3>
          <p style={{ maxWidth: '250px', margin: '0 auto' }}>
          {this.trans('description')}
          </p>
        </header>

        <div className="content">
          <form onSubmit={this.submitForm}>
            <fieldset>
              <legend className="visuallyhidden">Phone Number Form</legend>
              <CommunicateBox
                isStatic
                isSuccess
                message={'Pomyślnie zmieniono hasło'}
                show={this.props.showCommunicate}
                hideCallback={() => this.props.changeShowCommunicate(false)}
              />
              <ul className="list-fields list-none mb-40">
                <li className="list-fields__item">
                  <InputPhoneNr
                    ref={this.inputPhoneRef}
                    changePhoneCountry={this.props.changePhoneCountry}
                    changePhoneNumber={this.props.changePhoneNumber}
                    errorPhone={errors.phone}
                    phoneNumber={phone}
                    phoneCountry={phoneCountry}
                    className="list-fields__phone-nr"
                    locale={this.props.locale}
                  />
                </li>
              </ul>

              <p className="text-right text-small mb-30" style={{ marginTop: '-10px' }}>
                {this.trans('remember')}<AppLink to="routes.url.login">{this.trans('goBack')}</AppLink>
              </p>

              {isLoading
                ?
                <LoadingSpinner className="button button--expand" />
                :
                <button className="button button--expand">{this.trans('resetPasswordButton')}</button>
              }
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default PhoneForm;